import React, { useContext, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { PropTypes } from "prop-types";

import { QrCode } from "@common/components/qrCode";
import { usePrevious } from "@common/hooks/previous";
import { PopupContext } from "@app/dev/contexts/popup";
import ToastWrapper from "@common/helpers/toastWrapper";
import { useTranslation } from "@common/hooks/translation";
import { useBalance } from "@app/dev/terminal/hooks/balance";
import { depositMethods } from "@app/dev/constants/depositMethods";
import { OctoOperationsEnum } from "@app/dev/constants/enums/octoOperations";
import { OctoAmountTypesEnum } from "@app/dev/constants/enums/octoAmountTypes";
import { TerminalDepositModesEnum } from "@app/dev/constants/enums/terminalDepositModes";
import { increaseLocalBalance, setLastMoneyInputType, setTerminalDepositMode } from "@app/dev/actions/terminal";

import "./styles.scss";
import { getOktoQrData } from "./service";

export const DepositContentOctopay = ({ type }) => {
  const t = useTranslation();
  const balance = useBalance();
  const dispatch = useDispatch();
  const previousBalance = usePrevious(balance);
  const [{ closePopup }] = useContext(PopupContext);
  const terminalDepositMode = useSelector((state) => state.terminal.depositMode);
  let depositModeUpdated = false;

  const depositQrData = useMemo(() => getOktoQrData(OctoAmountTypesEnum.Static, OctoOperationsEnum.Deposit), []);

  useEffect(() => {
    if (balance > previousBalance) {
      const depositAmount = balance - previousBalance;
      depositModeUpdated = true;

      dispatch(increaseLocalBalance(depositAmount));
      ToastWrapper("success", "Deposit was successfully done!");
      closePopup();
    }
  }, [balance, previousBalance, dispatch, terminalDepositMode, closePopup]);

  useEffect(() => {
    const prevDepositMode = terminalDepositMode;

    if (terminalDepositMode !== TerminalDepositModesEnum.Octo) {
      dispatch(setLastMoneyInputType(TerminalDepositModesEnum.Octo));

      return () => {
        if (!depositModeUpdated) {
          dispatch(setLastMoneyInputType(prevDepositMode));
        }
      };
    }
  }, [dispatch, depositModeUpdated]);

  return (
    <div className="popup-content popup-small">
      <h3 className="popup-title">{t("Deposit with {1}", depositMethods[type].name)}</h3>
      <div className="popup-main-content okto-popup-content">
        <p className="text-center">{t("To make your deposit, simply scan the qr code using your Okto pay app")}</p>
        <QrCode data={depositQrData} />
      </div>
      <div className="popup-actions">
        <button onClick={closePopup} className="popup-cancel-button">
          {t("Cancel")}
        </button>
      </div>
    </div>
  );
};

DepositContentOctopay.propTypes = {
  type: PropTypes.string.isRequired,
};
